<template>
    <div id="happycall">
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            HAPPY CALL
        </v-alert>
        <v-alert>
            <v-card-text>
                <v-container>
                    <div class="d-none d-sm-block">
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <span class="font-weight-bold"
                                    >Happy Call Status :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span>{{ detailcase.is_happyCall }}</span>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <span class="font-weight-bold"
                                    >ลูกค้าพอใจกับการบริการหรือไม่ (ช่าง)
                                    :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="2"
                                style="margin-top:-15px"
                            >
                                <span
                                    ><v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'L'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="red"
                                            >mdi-emoticon-sad</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'M'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon
                                            class="display-1 "
                                            color="amber darken-2"
                                            >mdi-emoticon-neutral</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'H'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="green"
                                            >mdi-emoticon-excited</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.subs[0]
                                                .sub_status_name ==
                                                'Clear by Phone'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="blue"
                                            >mdi-phone</v-icon
                                        >
                                    </v-btn>
                                </span>
                            </v-col>

                            <v-col cols="12" sm="6" md="3">
                                <span class="font-weight-bold"
                                    >Happy Call By :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span
                                    >{{ detailcase.hpc_name }}
                                    {{ detailcase.hpc_date }}</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <span style="font-size:13px;font-weight:bold;"
                                    >ลูกค้าพอใจกับการบริการหรือไม่ (แอดมิน)
                                    :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="2"
                                style="margin-top:-15px"
                            >
                                <span>
                                    <v-btn
                                        v-if="detailcase.hpc_level == 'L'"
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="red"
                                            >mdi-emoticon-sad</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="detailcase.hpc_level == 'M'"
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon
                                            class="display-1 "
                                            color="amber darken-2"
                                            >mdi-emoticon-neutral</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="detailcase.hpc_level == 'H'"
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="green"
                                            >mdi-emoticon-excited</v-icon
                                        >
                                    </v-btn></span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span class="font-weight-bold"
                                    >ช่างกรอก email ในใบงานมาหรือไม่ :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span>{{ detailcase.email_in_cso }}</span>
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                                <span class="font-weight-bold"
                                    >เหตุผล(ลูกค้า) :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span>{{ detailcase.hpc_level_reason }}</span>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span class="font-weight-bold"
                                    >ปัญหาได้รับการแก้ไขหรือไม่ :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span>{{
                                    detailcase.hpc_problem_resolve
                                }}</span>
                            </v-col>
                            <v-col cols="12" sm="6" md="2">
                                <span class="font-weight-bold"
                                    >Remark_Hpc :</span
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <span>{{ detailcase.hpc_remark }}</span>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_covid_1 != null &&
                                        detailcase.hpc_covid_1 != '' &&
                                        detailcase.hpc_covid_1 != undefined
                                "
                            >
                                <span class="font-weight-bold"
                                    >ช่างสวมหน้ากากตลอดเวลาหรือไม่ :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_covid_1 != null &&
                                        detailcase.hpc_covid_1 != '' &&
                                        detailcase.hpc_covid_1 != undefined
                                "
                            >
                                <span>{{ detailcase.hpc_covid_1 }}</span>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="4"
                                v-if="
                                    detailcase.hpc_covid_2 != null &&
                                        detailcase.hpc_covid_2 != '' &&
                                        detailcase.hpc_covid_2 != undefined
                                "
                            >
                                <span class="font-weight-bold"
                                    >ช่างล้างมือด้วยแอลกอฮอล์
                                    ก่อนและหลังซ่อมเครื่อง หรือไม่ :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="2"
                                v-if="
                                    detailcase.hpc_covid_2 != null &&
                                        detailcase.hpc_covid_2 != '' &&
                                        detailcase.hpc_covid_2 != undefined
                                "
                            >
                                <span>{{ detailcase.hpc_covid_2 }}</span>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_covid_3 != null &&
                                        detailcase.hpc_covid_3 != '' &&
                                        detailcase.hpc_covid_3 != undefined
                                "
                            >
                                <span class="font-weight-bold"
                                    >ช่างทำความสะอาดเครื่องหลังซ่อมเสร็จหรือไม่
                                    :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_covid_3 != null &&
                                        detailcase.hpc_covid_3 != '' &&
                                        detailcase.hpc_covid_3 != undefined
                                "
                            >
                                <span>{{ detailcase.hpc_covid_3 }}</span>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_cust_suggest != null &&
                                        detailcase.hpc_cust_suggest != '' &&
                                        detailcase.hpc_cust_suggest != undefined
                                "
                            >
                                <span class="font-weight-bold"
                                    >ข้อแนะนำจากลูกค้า :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_cust_suggest != null &&
                                        detailcase.hpc_cust_suggest != '' &&
                                        detailcase.hpc_cust_suggest != undefined
                                "
                            >
                                <span>{{ detailcase.hpc_cust_suggest }}</span>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_cust_recommend != null &&
                                        detailcase.hpc_cust_recommend != '' &&
                                        detailcase.hpc_cust_recommend !=
                                            undefined
                                "
                            >
                                <span class="font-weight-bold"
                                    >แบรนด์ที่ดีที่สุดสำหรับลูกค้า :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_cust_recommend != null &&
                                        detailcase.hpc_cust_recommend != '' &&
                                        detailcase.hpc_cust_recommend !=
                                            undefined
                                "
                            >
                                <span>{{ detailcase.hpc_cust_recommend }}</span>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span
                                    class="font-weight-bold"
                                    v-if="
                                        detailcase.hpc_cust_reason != null &&
                                            detailcase.hpc_cust_reason != '' &&
                                            detailcase.hpc_cust_reason !=
                                                undefined
                                    "
                                    >เหตุผลที่เลือกแบรนด์นี้ :</span
                                >
                            </v-col>
                            <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                v-if="
                                    detailcase.hpc_cust_reason != null &&
                                        detailcase.hpc_cust_reason != '' &&
                                        detailcase.hpc_cust_reason != undefined
                                "
                            >
                                <span>{{ detailcase.hpc_cust_reason }}</span>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="d-sm-none">
                        <v-row>
                            <v-col cols="12">
                                <span class="font-weight-bold"
                                    >Happy Call Status :
                                </span>
                                <span>{{ detailcase.is_happyCall }}</span>
                            </v-col>

                            <v-col cols="12">
                                <span class="font-weight-bold"
                                    >ลูกค้าพอใจกับการบริการหรือไม่ (ช่าง) :
                                </span>
                                <span
                                    ><v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'L'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="red"
                                            >mdi-emoticon-sad</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'M'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon
                                            class="display-1 "
                                            color="amber darken-2"
                                            >mdi-emoticon-neutral</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.ce_customer_level == 'H'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="green"
                                            >mdi-emoticon-excited</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            detailcase.subs[0]
                                                .sub_status_name ==
                                                'Clear by Phone'
                                        "
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="blue"
                                            >mdi-phone</v-icon
                                        >
                                    </v-btn>
                                </span>
                            </v-col>

                            <v-col cols="12">
                                <span class="font-weight-bold"
                                    >Happy Call By :
                                </span>
                                <span
                                    >{{ detailcase.hpc_name }}
                                    {{ detailcase.hpc_date }}</span
                                >
                            </v-col>

                            <v-col cols="12">
                                <span style="font-weight:bold;"
                                    >ลูกค้าพอใจกับการบริการหรือไม่ (แอดมิน) :
                                </span>
                                <span>
                                    <v-btn
                                        v-if="detailcase.hpc_level == 'L'"
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="red"
                                            >mdi-emoticon-sad</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="detailcase.hpc_level == 'M'"
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon
                                            class="display-1 "
                                            color="amber darken-2"
                                            >mdi-emoticon-neutral</v-icon
                                        >
                                    </v-btn>
                                    <v-btn
                                        v-if="detailcase.hpc_level == 'H'"
                                        class="ma-2"
                                        text
                                        required
                                    >
                                        <v-icon class="display-1 " color="green"
                                            >mdi-emoticon-excited</v-icon
                                        >
                                    </v-btn></span
                                >
                            </v-col>

                            <v-col cols="12">
                                <span class="font-weight-bold"
                                    >ช่างกรอก email ในใบงานมาหรือไม่ :
                                </span>
                                <span>{{ detailcase.email_in_cso }}</span>
                            </v-col>

                            <v-col cols="12" sm="6" md="2">
                                <span class="font-weight-bold"
                                    >เหตุผล(ลูกค้า) : </span
                                ><span>{{ detailcase.hpc_level_reason }}</span>
                            </v-col>

                            <v-col cols="12">
                                <span class="font-weight-bold"
                                    >ปัญหาได้รับการแก้ไขหรือไม่ : </span
                                ><span>{{
                                    detailcase.hpc_problem_resolve
                                }}</span>
                            </v-col>

                            <v-col cols="12">
                                <span class="font-weight-bold"
                                    >Remark_Hpc :
                                </span>
                                <span>{{ detailcase.hpc_remark }}</span>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </v-card-text>
        </v-alert>
    </div>
</template>
<script>
import axios from "axios"

export default {
    mounted() {},
    props: ["detailcase"],
    data() {
        return {
            button: ["", "hover1", "hover1", "hover1"],
        }
    },
    methods: {
        selected(e) {
            this.button = ["", "hover1", "hover1", "hover1"]
            this.button[e] = "hover"
        },
    },
}
</script>
<style scoped>
.hover {
    background: blue;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
}
</style>
